export enum ClientTab {
    ALL_CLIENTS = 'all-clients',
    INVITES = 'invites',
    MY_CLIENTS = 'my-clients',
    ONBOARDING = 'onboarding',
}
